import Image1 from "../../assets/project1.png";
import Image2 from "../../assets/project2.png";
import Image3 from "../../assets/project3.jpg";
import Image4 from "../../assets/project4.jpg";
import Image5 from "../../assets/project5.jpeg";

const data = [
  {
    id: 1,
    category: "frontend",
    image: Image1,
    title: "Login Page",
    desc: "In this login page, I designed a responsive layout with a clean and modern aesthetic.",
    github: "https://github.com/20R01A0470/login-page",
  },

  {
    id: 2,
    category: "games",
    image: Image2,
    title: "Tic Tac Toe",
    desc: "In this TicTacToe game, I implemented the classic game logic using JavaScript.",
    github: "https://github.com/20R01A0470/tic-tac-toe-game",
  },

  {
    id: 3,
    category: "python",
    image: Image3,
    title: "My Own Alexa",
    desc: "In this MyOwnAlexa project, I created a voice-controlled virtual assistant using Python.",
    github: "https://github.com/20R01A0470/my-own-alexa",
  },

  {
    id: 4,
    category: "backend",
    image: Image4,
    title: "Hospital Management System",
    desc: "The objective of the Hospital Management System (HMS) project is to design and implement an efficient and user-friendly system that automates the various tasks associated with managing a hospital.",
    github: "",
  },

  {
    id: 5,
    category: "frontend",
    image: Image5,
    title: "Portfolio Website",
    desc: "In this Portfolio Website project, I developed a personal portfolio website to showcase my projects and Technical skills.",
    github: "",
  },
];

export default data;
